import { render, staticRenderFns } from "./fee-list.vue?vue&type=template&id=959dd540&"
import script from "./fee-list.vue?vue&type=script&lang=ts&"
export * from "./fee-list.vue?vue&type=script&lang=ts&"
import style0 from "./fee-list.vue?vue&type=style&index=0&id=959dd540&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports